interface DetailRowProps {
  label: string;
  value?: string | number;
  className?: string;
}

export const DetailRow = ({ label, value, className }: DetailRowProps) => (
  <div className="flex items-center gap-2">
    <span className={`${className ?? " text-sm font-bold text-gray-600"}  `}>{label}</span>
    <span className={`${className ?? " text-sm font-medium text-gray-600"}`}>{value}</span>
  </div>
);
